module.exports = __webpack_public_path__ + "media/images/icons/curriculum-journey-full-dbc808a35efa1b3a5e9c1950e88e8e6e.png";